import { RSAA } from 'redux-api-middleware';

export const FETCH_ADDRESS = 'FETCH_ADDRESS';
export const FETCH_ADDRESS_SUCCESS = 'FETCH_ADDRESS_SUCCESS';
export const FETCH_ADDRESS_FAILED = 'FETCH_ADDRESS_FAILED';
export const SELECT_ADDRESS = 'SELECT_ADDRESS';
export const SELECT_ADDRESS_SUCCESS = 'SELECT_ADDRESS_SUCCESS';
export const SELECT_ADDRESS_FAIL = 'SELECT_ADDRESS_FAIL';

export const onAddManuallyClick = (type, data) => ({
  type: `${type}ManuallyClicked`,
  data,
  meta: {
    key: type
  }
});

export const onFindAddressClick = (postCode, key) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/ref/address/search/${postCode}`,
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: `${key}${FETCH_ADDRESS}`,
        meta: {
          loading: true
        }
      },
      {
        type: `${key}${FETCH_ADDRESS_SUCCESS}`,
        meta: {
          loading: false,
          key: key
        }
      },
      {
        type: `${key}${FETCH_ADDRESS_FAILED}`,
        meta: {
          loading: false,
          key: key
        }
      }
    ]
  }
});

export const onSelectAddressClick = (address, type) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/ref/address/${address}`,
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: `${type}${SELECT_ADDRESS}`,
        meta: {
          loading: true
        }
      },
      {
        type: `${type}${SELECT_ADDRESS_SUCCESS}`,
        meta: {
          loading: false
        }
      },
      {
        type: `${type}${SELECT_ADDRESS_FAIL}`,
        meta: {
          loading: false
        }
      }
    ]
  }
});
